<template>
    <div>

        <v-container v-if="form" fluid>
            <v-row>
                <v-col md="4" class="d-flex align-items-center">
                    <v-switch
                        :input-value="isEnabled"
                        @change="toggleEnable"
                        color="primary"
                        dense>
                    </v-switch>
                    <span class="subtitle-2">Enable Fallback</span>
                </v-col>
            </v-row>
        </v-container>

        <v-form
            v-if="form && isEnabled"
            ref="form"
            v-model="valid"
            @submit="onSubmit"
            class="mt-3">
            <v-container fluid>

                <v-row>
                    <v-col md="4">
                        <v-text-field
                            v-model="form.title"
                            :error-messages="titleErrors"
                            required
                            label="Title"
                            @input="$v.form.title.$touch()"
                            @blur="$v.form.title.$touch()">
                        </v-text-field>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col md="4">
                        <v-text-field
                            v-model="form.description"
                            :error-messages="descErrors"
                            required
                            label="Description"
                            @input="$v.form.description.$touch()"
                            @blur="$v.form.description.$touch()">
                        </v-text-field>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col md="4">
                        <v-text-field
                            label="Price"
                            :error-messages="priceErrors"
                            v-model="form.price"
                            required
                            type="number"
                            @input="$v.form.price.$touch()"
                            @blur="$v.form.price.$touch()">
                        </v-text-field>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col>
                        <v-spacer></v-spacer>
                        <v-btn class="mt-4" small type="submit" color="primary">Save</v-btn>
                    </v-col>
                </v-row>

            </v-container>
        </v-form>
    </div>
</template>

<script>

import { validationMixin } from 'vuelidate'
import { required, decimal } from 'vuelidate/lib/validators'
import { EventBus } from '../../../../../../event-bus.js'
import { mapState } from 'vuex'

const target = '/api/live-rates/settings/fallback';

export default {


    props: {
        id: { type: Number, default: null },
    },

    mixins: [validationMixin],
    validations: {
        form: {
            price: { required, decimal },
            title: { required },
            description: { required },
        },
    },

    computed: {
        titleErrors() {
            const errors = []
            if (!this.$v.form.title.$dirty) return errors

            !this.$v.form.title.required && errors.push('Title is required.')
            return errors
        },

        descErrors() {
            const errors = []
            if (!this.$v.form.description.$dirty) return errors

            !this.$v.form.description.required && errors.push('Description is required.')
            return errors
        },

        priceErrors() {

            const errors = []
            if (!this.$v.form.price.$dirty) return errors

            !this.$v.form.price.required && errors.push('Price is required.')
            !this.$v.form.price.decimal && errors.push('Price must be number only.')
            return errors
        },


        integrationId() {
            return this.id;
        }

    },


    data() {
        return {
            valid: false,
            form: {
                price: 0,
                title: '',
                description: ''
            },
            isEnabled: false,
            isLoading: false,
            settings: null
        }
    },

    mounted() {
        this.fetchFallbackSettings();
    },

    methods: {
        async onSubmit(e) {

            this.$v.form.$touch()

            e.preventDefault()

            if (this.valid) {
                await this.$http.post(`${target}/${this.integrationId}/`, this.form)

                EventBus.$emit('show-success', 'Live Rates Fallback Saved.')
            }
        },

        async toggleEnable(mode) {

            try {
                await this.$http.post(`${target}/${this.integrationId}/enable`, { mode })
                this.fetchFallbackSettings()

            } catch(err) {
                EventBus.$emit('show-error', err)
            }


        },


        async fetchFallbackSettings() {
            try {
                this.isLoading = true
                let id = this.integrationId

                if (!id) {
                    return
                }


                const { data } = await this.$http.get(`${target}/${id}`)

                if (!data) {
                    return
                }


                this.isEnabled = data.enabled
                if (data.result) {
                    this.form = data.result
                }

                this.isLoading = false
            } catch(error) {
                EventBus.$emit('show-error', error)
            }
        },
    },


}

</script>